@let testIdPrefix = 'rcp-' + tableId() + '-table';

<div
    class="rcp-flex rcp-flex-col rcp-gap-3 md:rcp-flex-row md:rcp-items-center md:rcp-justify-between"
>
    <ng-content></ng-content>
    <h3
        class="rcp-font-poppins rcp-text-2xl"
        [attr.data-testid]="'title' | testid: testIdPrefix"
    >
        {{ tableTitle() }}
    </h3>

    <div class="rcp-inline-flex rcp-gap-3">
        @if (searchNote().length > 0) {
            <div class="rcp-mt-[7px]">
                <span class="rcp-text-sm rcp-text-ul-dark-200">
                    {{ searchNote() }}
                </span>
            </div>
        }
        <div class="rcp-relative rcp-flex-auto md:rcp-w-[240px]">
            @if (tableHasData() && !hasNoSearch()) {
                <input
                    #searchTable
                    type="text"
                    class="rcp-block rcp-w-full rcp-rounded-full rcp-border-0 rcp-py-2 rcp-pl-4 rcp-pr-10 rcp-text-sm/6 rcp-font-normal rcp-text-ul-dark-300 rcp-ring-1 rcp-ring-inset rcp-ring-ul-dark-200 placeholder:rcp-text-ul-dark-300 focus:rcp-ring-2 focus:rcp-ring-inset focus:rcp-ring-ul-blue-400"
                    placeholder="Search"
                    type="text"
                    [attr.data-testid]="'search' | testid: testIdPrefix"
                    [(ngModel)]="inputSearch"
                    (input)="onSearch()"
                />
                @if (inputSearch()) {
                    <button
                        type="button"
                        class="rcp-absolute rcp-inset-y-0 rcp-end-0 rcp-flex rcp-items-center rcp-pe-3"
                        [attr.data-testid]="'search-clear-btn' | testid: testIdPrefix"
                        [disabled]="tableLoading()"
                        (click)="onClearSearch(searchTable)"
                    >
                        <mat-icon
                            class="rcp-text-ul-dark-300"
                            [ngClass]="{ 'rcp-text-gray-500': tableLoading() }"
                            >cancel</mat-icon
                        >
                    </button>
                } @else {
                    <div
                        class="rcp-pointer-events-none rcp-absolute rcp-inset-y-0 rcp-right-0 rcp-flex rcp-w-8 rcp-items-center rcp-pr-3"
                    >
                        <mat-icon
                            class="rcp-text-ul-dark-300"
                            [attr.data-testid]="'search-icon' | testid: testIdPrefix"
                            >search</mat-icon
                        >
                    </div>
                }
            }
        </div>
        <div>
            @if (tableActions().actions) {
                <button
                    *appIsGranted="tableActions().roles || []"
                    mat-flat-button
                    type="button"
                    [attr.data-testid]="
                        tableActions().testId + 'btn' | testid: testIdPrefix
                    "
                    [matMenuTriggerFor]="dropdownBtn"
                >
                    <mat-icon class="rcp-text-white">add</mat-icon>

                    <div class="rcp-inline-flex rcp-items-center">
                        {{ tableActions().label }}

                        <mat-icon class="-rcp-mr-2 rcp-ml-2 rcp-text-white"
                            >arrow_drop_down</mat-icon
                        >
                    </div>
                </button>

                <mat-menu
                    #dropdownBtn="matMenu"
                    class="last:!rcp-border-b-0"
                >
                    @for (action of tableActions().actions; track action.label) {
                        <button
                            mat-menu-item
                            class="rcp-table-menu"
                            type="button"
                            [attr.data-testid]="action + 'btn' | testid: testIdPrefix"
                            [disabled]="action.disabled"
                            (click)="buttonAction(action)"
                        >
                            <div
                                class="rcp-inline-flex !rcp-w-[243px] rcp-items-center rcp-py-[14px] rcp-leading-tight"
                            >
                                <span class="rcp-text-base">
                                    {{ action.label }}
                                </span>
                            </div>
                            @if (action.subLabel) {
                                <div class="-rcp-mt-[10px]">
                                    <span>{{ action.subLabel }}</span>
                                </div>
                            }
                        </button>
                    }
                </mat-menu>
            } @else {
                <button
                    mat-flat-button
                    [attr.data-testid]="
                        tableActions().testId + 'btn' | testid: testIdPrefix
                    "
                    [disabled]="tableActions().disabled"
                    (click)="buttonAction(tableActions())"
                >
                    <mat-icon
                        class="{{
                            tableActions().disabled
                                ? 'rcp-text-ul-dark-200'
                                : 'rcp-text-white'
                        }}"
                        >add</mat-icon
                    >

                    <div class="rcp-inline-flex rcp-items-center">
                        {{ tableActions().label }}
                    </div>
                </button>
            }
        </div>
    </div>
</div>

<div class="rcp-flow-root rcp-min-w-full rcp-overflow-x-auto">
    <div class="rcp-inline-block rcp-min-w-full rcp-py-6 rcp-align-middle">
        @if (tabs().length > 0) {
            <div class="rcp-mb-6">
                <nav
                    mat-tab-nav-bar
                    animationDuration="0ms"
                    mat-stretch-tabs="false"
                    mat-align-tabs="start"
                    [tabPanel]="tabTablePanel"
                >
                    @for (tab of tabs(); track tab.name) {
                        <button
                            type="button"
                            mat-tab-link
                            [active]="tab.active"
                            [attr.data-testid]="
                                tableActions().testId + tab.testId | testid: testIdPrefix
                            "
                            (click)="onSelectTab(tab)"
                        >
                            {{ tab.name }}
                        </button>
                    }
                </nav>
                <mat-tab-nav-panel #tabTablePanel></mat-tab-nav-panel>
            </div>
        }

        @if (notFoundContent().btnText === '' || notFoundContent().baseTitle === '') {
            <div class="rcp-min-h-[500px] rcp-w-full rcp-bg-ul-gray-150"></div>
        } @else if (tableInitialLoading()) {
            <div
                class="rcp-flex rcp-min-h-[500px] rcp-w-full rcp-flex-col rcp-items-center rcp-justify-center rcp-bg-ul-gray-150"
            >
                <mat-spinner
                    class="rcp-mx-auto rcp-my-8"
                    [diameter]="50"
                ></mat-spinner>
            </div>
        } @else if (tableHasError()) {
            <app-not-found
                [title]="errorContent().title"
                [description]="errorContent().message"
                [showButton]="true"
                [retryText]="errorContent().retryText || ''"
                (onRetryAction)="errorContent().onRetryAction()"
            />
        } @else if (tableData().length === 0 && inputSearch()) {
            <app-not-found
                [title]="notFoundContent().subTitle ?? ''"
                [description]="notFoundContent().subDescription ?? ''"
            />
        } @else if (!tableHasData()) {
            <app-not-found
                [title]="notFoundContent().baseTitle"
                [description]="notFoundContent().baseDescription"
                [showButton]="true"
                [addBtnText]="notFoundContent().btnText || ''"
                (onAddAction)="notFoundContentAction()"
            >
            </app-not-found>
        } @else {
            <div
                class="rcp-overflow-y-hidden rcp-rounded-lg rcp-border-[1px] rcp-border-ul-gray-350"
            >
                <table
                    mat-table
                    class="{{
                        fullRowSelection() ? 'rcp-full-row-selection' : ''
                    }} !rcp-border-b-[1px] !rcp-border-ul-gray-350"
                    [attr.data-testid]="'container' | testid: testIdPrefix"
                    [dataSource]="tableData()"
                >
                    @for (column of columns(); track column.id) {
                        @if (column.dataIndex === 'actions') {
                            <ng-container matColumnDef="{{ column.dataIndex }}">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell
                                    width="40"
                                    class="!rcp-p-0"
                                    [attr.data-testid]="
                                        'header-' + column.dataIndex
                                            | testid: testIdPrefix
                                    "
                                >
                                    <div class="rcp-sr-only">
                                        {{ column.title }}
                                    </div>
                                </th>
                                <td
                                    *matCellDef="let element"
                                    mat-cell
                                    class="!rcp-p-0"
                                >
                                    @if (
                                        column.actions &&
                                        !(column.isHidden && column.isHidden(element))
                                    ) {
                                        <button
                                            mat-icon-button
                                            [attr.data-testid]="
                                                'menu-btn' | testid: testIdPrefix
                                            "
                                            [matMenuTriggerFor]="actionBtn"
                                            [disabled]="
                                                column.actionsStatus
                                                    ? column.actionsStatus(element)
                                                    : false
                                            "
                                        >
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #actionBtn="matMenu">
                                            @for (
                                                action of column.actions;
                                                track action.id
                                            ) {
                                                <button
                                                    mat-menu-item
                                                    [attr.data-testid]="
                                                        'menu-' +
                                                            action.label?.toLocaleLowerCase() +
                                                            '-btn' | testid: testIdPrefix
                                                    "
                                                    [disabled]="action.disabled"
                                                    (click)="
                                                        action.onClick({
                                                            id: element[rowId()],
                                                            callback:
                                                                onFetchTable.bind(this),
                                                            rowData: element,
                                                        })
                                                    "
                                                >
                                                    <div
                                                        class="rcp-inline-flex !rcp-w-[176px] rcp-items-center rcp-py-[14px]"
                                                    >
                                                        @if (action.icon) {
                                                            <mat-icon
                                                                class="material-icons-outlined"
                                                                >{{
                                                                    action.icon
                                                                }}</mat-icon
                                                            >
                                                        }

                                                        <span class="rcp-text-base">
                                                            {{ action.label }}
                                                        </span>
                                                    </div>
                                                </button>
                                            }
                                        </mat-menu>
                                    }
                                </td>
                            </ng-container>
                        } @else {
                            <ng-container matColumnDef="{{ column.dataIndex }}">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell
                                    class="rcp-group/column !rcp-font-semibold rcp-text-gray-900"
                                    [attr.data-testid]="
                                        'header-' + column.dataIndex.toLocaleLowerCase()
                                            | testid: testIdPrefix
                                    "
                                >
                                    <div class="rcp-inline-flex rcp-items-center">
                                        {{ column.title }}
                                        @if (column.sort) {
                                            <button
                                                matRipple
                                                class="rcp-group/sort rcp-invisible rcp-ml-1.5 rcp-inline-flex !rcp-h-7 !rcp-w-7 rcp-items-center rcp-rounded rcp-bg-ul-gray-200 rcp-p-1 rcp-text-black disabled:rcp-bg-ul-gray-150 group-hover/column:rcp-visible"
                                                type="button"
                                                [ngClass]="{
                                                    'rcp-invisible':
                                                        tableSortBy() !==
                                                        column.dataIndex,
                                                    'rcp-visible':
                                                        tableSortBy() ===
                                                        column.dataIndex,
                                                }"
                                                [attr.data-testid]="
                                                    'sort-btn' | testid: testIdPrefix
                                                "
                                                (click)="
                                                    onSortColumn(
                                                        tableSort(),
                                                        column.dataIndex
                                                    )
                                                "
                                            >
                                                @if (
                                                    tableSort() === sortDesc &&
                                                    tableSortBy() === column.dataIndex
                                                ) {
                                                    <mat-icon svgIcon="descend">
                                                        <span
                                                            class="rcp-sr-only"
                                                            [attr.data-testid]="
                                                                'sort-descending'
                                                                    | testid: testIdPrefix
                                                            "
                                                        >
                                                            {{ 'descending' }}
                                                        </span>
                                                    </mat-icon>
                                                } @else if (
                                                    tableSort() === sortAsc &&
                                                    tableSortBy() === column.dataIndex
                                                ) {
                                                    <mat-icon svgIcon="ascend">
                                                        <span
                                                            class="rcp-sr-only"
                                                            [attr.data-testid]="
                                                                'sort-ascending'
                                                                    | testid: testIdPrefix
                                                            "
                                                        >
                                                            {{ 'ascending' }}
                                                        </span>
                                                    </mat-icon>
                                                } @else {
                                                    <mat-icon svgIcon="new-sort">
                                                        <span
                                                            class="rcp-sr-only"
                                                            [attr.data-testid]="
                                                                'sort-default'
                                                                    | testid: testIdPrefix
                                                            "
                                                        >
                                                            {{ 'default sort' }}
                                                        </span>
                                                    </mat-icon>
                                                }
                                            </button>
                                        }
                                    </div>
                                </th>
                                <td
                                    *matCellDef="let element"
                                    mat-cell
                                    [matTooltip]="
                                        column.showToolTip && element[column.dataIndex]
                                            ? element[column.dataIndex]
                                            : null
                                    "
                                    [matTooltipClass]="'rcp-table-tooltip'"
                                    [ngClass]="column.className"
                                    [attr.data-testid]="
                                        'cell-' + column.dataIndex | testid: testIdPrefix
                                    "
                                    (click)="onFullRowClickAction($event, element)"
                                >
                                    @if (
                                        column.renderCell &&
                                        column.renderCell(element).length > 0
                                    ) {
                                        <div class="rcp-py-2">
                                            @for (
                                                cell of column.renderCell(element);
                                                track $index
                                            ) {
                                                <div
                                                    class="rcp-mb-2"
                                                    [ngClass]="{
                                                        'rcp-mb-2':
                                                            $index !==
                                                            column.renderCell(element)
                                                                .length -
                                                                1,
                                                    }"
                                                >
                                                    <ng-template
                                                        *ngComponentOutlet="
                                                            cell.render;
                                                            inputs: cell.input
                                                        "
                                                    />
                                                </div>
                                            }
                                        </div>
                                    } @else if (
                                        statusBadge.includes(
                                            column.dataIndex.toLocaleLowerCase()
                                        )
                                    ) {
                                        <span
                                            class="rcp-inline-flex rcp-items-center rcp-rounded-md rcp-px-2 rcp-py-1 rcp-text-xs rcp-font-medium  {{
                                                statusColor(element[column.dataIndex])
                                            }}"
                                        >
                                            @if (statusIcon(element[column.dataIndex])) {
                                                <mat-icon
                                                    class="material-icons-outlined rcp-mr-1 !rcp-h-[16px] !rcp-w-[16px] !rcp-text-[16px]"
                                                    >{{
                                                        statusIcon(
                                                            element[column.dataIndex]
                                                        )
                                                    }}
                                                </mat-icon>
                                            }

                                            <span
                                                [attr.data-testid]="
                                                    'table-cell-status'
                                                        | testid: testIdPrefix
                                                "
                                                >{{ element[column.dataIndex] }}</span
                                            >
                                        </span>
                                    } @else if (column.urlPattern) {
                                        @if (
                                            column.urlPattern(element['id'], element) ===
                                            ''
                                        ) {
                                            {{ element[column.dataIndex] }}
                                        } @else {
                                            <a
                                                class="rcp-underline"
                                                routerLink="{{
                                                    column.urlPattern(
                                                        element['id'],
                                                        element
                                                    )
                                                }}"
                                                [attr.data-testid]="
                                                    'table-cell-link'
                                                        | testid: testIdPrefix
                                                "
                                            >
                                                {{ element[column.dataIndex] }}
                                            </a>
                                        }
                                    } @else if (
                                        column.imagePath && element[column.imagePath]
                                    ) {
                                        <span
                                            class="rcp-inline-flex rcp-items-center rcp-rounded-md rcp-px-2 rcp-py-1 rcp-text-xs rcp-font-medium"
                                        >
                                            <img
                                                class="rcp-mr-1 !rcp-h-[20px] !rcp-w-[28px]"
                                                onerror="this.onerror=null; this.src='';this.hidden='true'"
                                                [src]="element[column.imagePath]"
                                                [attr.data-testid]="
                                                    'table-cell-country-image'
                                                        | testid: testIdPrefix
                                                "
                                            />
                                            <span
                                                [attr.data-testid]="
                                                    'table-cell-country'
                                                        | testid: testIdPrefix
                                                "
                                                >{{ element[column.dataIndex] }}</span
                                            >
                                        </span>
                                    } @else if (column.date) {
                                        {{
                                            element[column.dataIndex] | date: column.date
                                        }}
                                    } @else if (column.status) {
                                        <span
                                            class="rcp-inline-flex rcp-items-center rcp-rounded-md rcp-px-2 rcp-py-1 rcp-text-xs rcp-font-medium  {{
                                                statusColor(column.status)
                                            }}"
                                        >
                                            {{ element[column.dataIndex] }}</span
                                        >
                                    } @else {
                                        {{ element[column.dataIndex] }}
                                    }
                                </td>
                            </ng-container>
                        }
                    }

                    <tr
                        *matHeaderRowDef="columnsData()"
                        mat-header-row
                        class="!rcp-bg-ul-gray-200"
                    >
                        >
                    </tr>
                    <tr
                        *matRowDef="let row; columns: columnsData()"
                        mat-row
                    ></tr>
                </table>

                <div
                    class="rcp-w-full rcp-border-t-[1px] rcp-border-ul-gray-350 md:rcp-h-12"
                >
                    <div
                        class="rcp-flex rcp-w-full rcp-flex-col rcp-items-center rcp-justify-end rcp-px-4 md:rcp-flex-row"
                    >
                        <div
                            class="rcp-inline-flex rcp-items-center rcp-gap-2.5 rcp-px-4 rcp-py-2 rcp-text-sm"
                            [attr.data-testid]="
                                'page-size-section' | testid: testIdPrefix
                            "
                        >
                            <span class="rcp-inline-block">
                                {{ 'Page Size' }}
                            </span>
                            <span>
                                <div class="rcp-relative rcp-flex-auto">
                                    <label
                                        for="page-size"
                                        class="rcp-sr-only"
                                        >{{ 'Page Size' }}</label
                                    >
                                    <select
                                        id="page-size"
                                        class="rcp-inline-block rcp-w-full rcp-appearance-none rcp-rounded-[3px] rcp-border-0 rcp-bg-no-repeat rcp-py-1.5 rcp-pl-[13px] rcp-pr-[2.5rem] rcp-text-sm rcp-text-ul-dark-300 rcp-ring-1 rcp-ring-inset rcp-ring-ul-dark-500 focus:rcp-ring-2 focus:rcp-ring-ul-blue-400"
                                        [attr.data-testid]="
                                            'select-page-size' | testid: testIdPrefix
                                        "
                                        [value]="tablePageSize()"
                                        (change)="onChangePageSize($event)"
                                    >
                                        @for (pageSize of pageSizeList; track pageSize) {
                                            <option
                                                value="{{ pageSize }}"
                                                [attr.data-testid]="
                                                    'select-page-size-' + pageSize
                                                        | testid: testIdPrefix
                                                "
                                                [selected]="tablePageSize() === pageSize"
                                            >
                                                {{ pageSize }}
                                            </option>
                                        }
                                    </select>

                                    <div
                                        class="rcp-pointer-events-none rcp-absolute rcp-inset-y-0 rcp-right-0 rcp-flex rcp-w-8 rcp-items-center rcp-pr-3"
                                    >
                                        <mat-icon
                                            class="!rcp-h-[20px] !rcp-w-[20px] rcp-text-[20px] rcp-text-ul-dark-300"
                                            >arrow_drop_down</mat-icon
                                        >
                                    </div>
                                </div>
                            </span>
                            <span
                                class="rcp-inline-block rcp-pl-2"
                                [attr.data-testid]="
                                    'page-size-label' | testid: testIdPrefix
                                "
                            >
                                <b class="rcp-font-extrabold">
                                    {{
                                        (tablePage() - 1) * tablePageSize() + 1
                                            | number: '1.0-0'
                                    }}
                                </b>
                                {{ '-' }}
                                <b class="rcp-font-extrabold">
                                    {{
                                        (tablePage() === tableTotalPages()
                                            ? tableTotalCount()
                                            : tablePage() * tablePageSize()
                                        ) | number: '1.0-0'
                                    }}
                                </b>
                                {{ 'of' }}
                                <b class="rcp-font-extrabold">
                                    {{ tableTotalCount() | number: '1.0-0' }}
                                </b>
                            </span>
                        </div>
                        <nav
                            class="rcp-inline-flex rcp-flex-wrap rcp-items-center rcp-space-x-1 rcp-px-4"
                            [attr.data-testid]="
                                'pagination-section' | testid: testIdPrefix
                            "
                        >
                            <button
                                mat-icon-button
                                class="!rcp-inline-flex"
                                [attr.data-testid]="
                                    'pagination-first-btn' | testid: testIdPrefix
                                "
                                [disabled]="tablePage() === 1"
                                (click)="onChangePage(1)"
                            >
                                <mat-icon>first_page</mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                class="!rcp-inline-flex"
                                [attr.data-testid]="
                                    'pagination-previous-btn' | testid: testIdPrefix
                                "
                                [disabled]="tablePage() === 1"
                                (click)="onChangePage(tablePage() - 1)"
                            >
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>

                            <div class="rcp-inline-flex rcp-items-center">
                                <p
                                    class="rcp-text-sm rcp-text-black"
                                    [attr.data-testid]="
                                        'pagination-label' | testid: testIdPrefix
                                    "
                                >
                                    {{ 'Page' }}
                                    <span class="rcp-relative">
                                        <span
                                            class="rcp-px-4"
                                            aria-hidden="true"
                                            >{{ inputPage() }}</span
                                        >
                                        <input
                                            type="text"
                                            class="rcp-absolute rcp-left-1/2 rcp-top-1/2 rcp-inline-block rcp-h-8 rcp-w-full -rcp-translate-x-1/2 -rcp-translate-y-1/2 rcp-transform rcp-rounded-[3px] rcp-px-2 rcp-py-1.5 rcp-text-center rcp-text-sm rcp-text-ul-dark-300 rcp-ring-1 rcp-ring-inset rcp-ring-ul-dark-500 focus:rcp-ring-2 focus:rcp-ring-ul-blue-400"
                                            [attr.data-testid]="
                                                'pagination-input-page'
                                                    | testid: testIdPrefix
                                            "
                                            [(ngModel)]="inputPage"
                                            (keypress)="
                                                ($event.charCode >= 48 &&
                                                    $event.charCode < 58)
                                            "
                                            (input)="onTypePage()"
                                        />
                                    </span>
                                    {{ 'of ' }}
                                    <b class="rcp-font-extrabold">{{
                                        tableTotalPages() | number: '1.0-0'
                                    }}</b>
                                </p>
                            </div>

                            <button
                                mat-icon-button
                                class="!rcp-inline-flex"
                                [attr.data-testid]="
                                    'pagination-next-btn' | testid: testIdPrefix
                                "
                                [disabled]="tablePage() === tableTotalPages()"
                                (click)="onChangePage(tablePage() + 1)"
                            >
                                <mat-icon> keyboard_arrow_right </mat-icon>
                            </button>

                            <button
                                mat-icon-button
                                class="!rcp-inline-flex"
                                [attr.data-testid]="
                                    'pagination-last-btn' | testid: testIdPrefix
                                "
                                [disabled]="tablePage() === tableTotalPages()"
                                (click)="onChangePage(tableTotalPages())"
                            >
                                <mat-icon> last_page </mat-icon>
                            </button>
                        </nav>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
